import { Connect } from '@genesislcap/foundation-comms';
import { DatasourceConfiguration } from '@genesislcap/foundation-entity-management';
import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { IEnumService } from '../../../services/enum.service';
import { ThirdPartyColumnConfig } from './column-config';
import { ThirdPartyStyles as styles } from './third-party.styles';
import { ThirdPartyTemplate as template } from './third-party.template';

export enum Permissions {
  add,
  edit,
  delete,
}

@customElement({
  name: 'third-party-management',
  template: template,
  styles: styles,
})
export class ThirdParty extends FASTElement {
  @observable datasourceConfig: DatasourceConfiguration;
  @attr resourceName = 'ALL_THIRD_PARTY_INTEGRATION';

  @observable columns: any = ThirdPartyColumnConfig(this);
  @observable permissions: Permissions[] = [];
  @IEnumService enumService: IEnumService;

  @attr entityID: string = 'USER_NAME';
  @attr entityLabel: string = 'Subscription Tier';
  @attr availableEntitiesEndpoint: string = 'ALL_THIRD_PARTY_INTEGRATION';

  @observable gridOptions = {
    scrollbarWidth: 10,
  };

  constructor() {
    super();
  }
}
